// extracted by mini-css-extract-plugin
export default {"productGrid":"Z0-z","centerLink":"_0-z","productSection":"a1-z","item":"b1-z","ctaButton":"c1-z"};